import React from 'react';
import SurveyTaking from '../Survey/SurveyTaking';
import caregiverService from '../../services/caregiverService';

/**
 * Caregiver (ObsRO) survey-taking surface (FECOA-1320, slice #5).
 *
 * Reuses the participant `SurveyTaking` component wholesale (same screens, same
 * `ScreenRenderer`) and only swaps the data layer: an adapter that points the
 * load / save / submit calls at the caregiver endpoints. ObsRO surveys use the
 * fast-nav (load-all-screens) path; linked-survey, adaptive, and legacy
 * question-by-question calls are not exercised, so they resolve to safe no-ops.
 */
const caregiverSurveyApi = {
  loadAllScreens: (assignmentId) => caregiverService.loadScreens(assignmentId),
  saveResponse: (assignmentId, questionId, responseData) =>
    caregiverService.saveResponse(assignmentId, questionId, responseData),
  submitSurvey: (assignmentId) => caregiverService.submitSurvey(assignmentId),
  // The caregiver submit endpoint already marks the assignment completed.
  updateAssignmentStatus: async () => ({}),
  // ObsRO surveys are not chained; no linked next-assignment.
  getNextLinkedAssignment: async () => null,
  // Validity polling only reacts to thrown errors; a resolved no-op is inert.
  checkSessionValid: async () => ({ valid: true }),
  // Legacy / adaptive paths are unused by the fast-nav ObsRO flow.
  getSurveyProgress: async () => ({}),
  getNextQuestion: async () => ({}),
  getPreviousQuestion: async () => ({}),
  getQuestionResponse: async () => null,
  getNextSequentialQuestion: async () => null,
};

const CaregiverSurveyTaking = () => (
  <SurveyTaking surveyApi={caregiverSurveyApi} homePath="/caregiver/dashboard" belowAppHeader={false} />
);

export default CaregiverSurveyTaking;
